module.exports = __webpack_public_path__ + "fonts/Nucleo.b1cf6f7.woff2";